import type { ReactNode } from "react";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { QueryProvider } from "@/providers/QueryProvider";
import { Toaster } from "@/components/molecules/Toaster";

/**
 * Único ponto de composição de providers globais.
 * Ordem importa: Theme antes de tudo (evita flash de tema errado),
 * Query envolvendo Auth (services de auth podem futuramente usar queries),
 * Toaster por último para poder renderizar toasts de qualquer contexto acima.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <QueryProvider>
        <AuthProvider>
          {children}
          <Toaster />
        </AuthProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}
